import { render, staticRenderFns } from "./addActivitiesView.vue?vue&type=template&id=3d0c2ad1"
import script from "./addActivitiesView.vue?vue&type=script&lang=js"
export * from "./addActivitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports